
(function(){
  'use strict';
  if(window.__smFoundationMediaV2){window.__smFoundationMediaV2.init(document);return;}
  var mounted=new Map();
  var playIcon='M4 2L14 8L4 14Z';
  var pauseIcon='M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5m5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5';
  function rootsWithin(scope){
    var roots=[];
    if(scope.matches&&scope.matches('[data-sm-root]'))roots.push(scope);
    if(scope.querySelectorAll)roots=roots.concat(Array.from(scope.querySelectorAll('[data-sm-root]')));
    return roots;
  }
  function init(scope){
    rootsWithin(scope).forEach(function(root){
      if(mounted.has(root))return;
      var groups=new Map(),controllers=[],removeListeners=[],frame=0,destroyed=false;
      var reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
      function listen(target,event,handler,options){target.addEventListener(event,handler,options);removeListeners.push(function(){target.removeEventListener(event,handler,options);});}
      function visible(video){
        if(document.hidden||!root.isConnected||!video.getClientRects().length)return false;
        var rect=video.getBoundingClientRect(),style=window.getComputedStyle(video);
        return style.visibility!=='hidden'&&rect.width>0&&rect.height>0&&rect.bottom>0&&rect.right>0&&rect.top<window.innerHeight&&rect.left<window.innerWidth;
      }
      function wanted(controller){return controller.group.intent==='play'||(controller.group.intent==='auto'&&!reduced.matches);}
      function render(controller){
        var video=controller.video,button=controller.button;
        if(!button)return;
        var failed=controller.failed||!!video.error,playing=!video.paused;
        button.setAttribute('aria-label',failed?'Retry video':controller.pending?'Cancel video loading':playing?'Pause video':'Play video');
        button.setAttribute('aria-pressed',String(playing||controller.pending));
        button.removeAttribute('aria-disabled');
        button.setAttribute('aria-busy',String(controller.pending));
        var path=button.querySelector('path');
        if(path)path.setAttribute('d',playing||controller.pending?pauseIcon:playIcon);
      }
      function stop(controller,release){
        var video=controller.video;
        if(video.readyState>0&&video.currentTime>0)controller.group.position=video.currentTime;
        controller.ticket++;controller.pending=false;
        video.pause();
        if(release){controller.active=false;video.preload='none';video.load();}
        render(controller);
      }
      function attempt(controller,retry){
        var video=controller.video;
        if(!visible(video)||!wanted(controller))return;
        if((controller.failed||video.error)&&!retry){render(controller);return;}
        if(retry){controller.failed=false;controller.ticket++;controller.pending=false;video.load();}
        if(controller.pending||!video.paused){render(controller);return;}
        var ticket=++controller.ticket;
        controller.pending=true;render(controller);
        var promise;
        try{promise=video.play();}catch(error){promise=Promise.reject(error);}
        Promise.resolve(promise).then(function(){
          if(destroyed||ticket!==controller.ticket)return;
          controller.pending=false;controller.failed=false;
          if(!visible(video)||!wanted(controller))video.pause();
          render(controller);
        }).catch(function(error){
          if(destroyed||ticket!==controller.ticket)return;
          controller.pending=false;
          controller.failed=!!video.error||!!(error&&error.name!=='AbortError'&&error.name!=='NotAllowedError');
          render(controller);
        });
      }
      function sync(){
        frame=0;
        if(destroyed)return;
        if(!root.isConnected){cleanup();return;}
        controllers.forEach(function(controller){
          if(!visible(controller.video)){if(controller.active)stop(controller,true);return;}
          if(!controller.active){controller.active=true;controller.video.preload='metadata';}
          if(wanted(controller))attempt(controller,false);else if(!controller.video.paused||controller.pending)stop(controller,false);
          else render(controller);
        });
      }
      function schedule(){if(!destroyed&&!frame)frame=window.requestAnimationFrame(sync);}
      var observer=window.IntersectionObserver?new window.IntersectionObserver(schedule,{threshold:[0,0.01]}):null;
      root.querySelectorAll('video[data-sm-media]').forEach(function(video){
        var key=video.dataset.smVideo||video.getAttribute('src');
        if(!groups.has(key))groups.set(key,{intent:'auto',position:0});
        var button=root.querySelector('[data-sm-toggle="'+video.dataset.smMedia+'"]');
        var controller={video:video,button:button,group:groups.get(key),active:false,pending:false,failed:false,ticket:0};
        controllers.push(controller);
        video.dataset.smReady='1';video.muted=true;video.defaultMuted=true;video.playsInline=true;
        video.autoplay=false;video.removeAttribute('autoplay');video.preload='none';video.pause();video.load();
        function toggle(){
          if(controller.pending||!video.paused){controller.group.intent='pause';controllers.forEach(function(other){if(other.group===controller.group)stop(other,false);});}
          else{controller.group.intent='play';controller.active=true;video.preload='metadata';attempt(controller,true);}
          sync();
        }
        if(button){listen(button,'click',toggle);if(button.tagName!=='BUTTON'){listen(button,'keydown',function(event){if((event.key==='Enter'||event.key===' ')&&!event.repeat){event.preventDefault();toggle();}});}}
        listen(video,'play',function(){if(!visible(video)||!wanted(controller))video.pause();render(controller);});
        listen(video,'pause',function(){render(controller);});
        listen(video,'error',function(){controller.ticket++;controller.pending=false;controller.failed=true;render(controller);});
        listen(video,'loadedmetadata',function(){
          if(controller.group.position>0&&Number.isFinite(video.duration)){try{video.currentTime=Math.min(controller.group.position,Math.max(0,video.duration-0.05));}catch(error){}}
          schedule();
        });
        listen(video,'emptied',function(){controller.failed=false;render(controller);schedule();});
        if(observer)observer.observe(video);
        render(controller);
      });
      listen(window,'resize',schedule,{passive:true});
      if(!observer)listen(window,'scroll',schedule,{passive:true});
      listen(document,'visibilitychange',function(){if(frame)window.cancelAnimationFrame(frame);frame=0;sync();});
      if(reduced.addEventListener)listen(reduced,'change',schedule);
      function cleanup(){
        if(destroyed)return;destroyed=true;
        if(frame)window.cancelAnimationFrame(frame);
        if(observer)observer.disconnect();
        removeListeners.forEach(function(remove){remove();});
        controllers.forEach(function(controller){stop(controller,true);delete controller.video.dataset.smReady;});
        mounted.delete(root);
      }
      mounted.set(root,cleanup);
      sync();
    });
  }
  function destroy(scope){rootsWithin(scope).forEach(function(root){var cleanup=mounted.get(root);if(cleanup)cleanup();});}
  window.__smFoundationMediaV2={init:init,destroy:destroy};
  document.addEventListener('shopify:section:load',function(event){init(event.target);});
  document.addEventListener('shopify:section:unload',function(event){destroy(event.target);});
  init(document);
})();

/* Shopify editor lifecycle: reveal the visible responsive copy and stop removed media. */
(function(){
  if(window.__smDashboardLifecycle)return;
  window.__smDashboardLifecycle=true;
  document.addEventListener('shopify:section:unload',function(event){
    event.target.querySelectorAll('[data-sm-root] video').forEach(function(video){video.pause();});
  });
  document.addEventListener('shopify:block:select',function(event){
    var section=event.target.closest('.shopify-section')||document;
    var id=event.detail&&event.detail.blockId;
    var candidates=Array.from(section.querySelectorAll('[data-shopify-editor-block]'));
    var visible=candidates.find(function(node){
      var data;try{data=JSON.parse(node.getAttribute('data-shopify-editor-block'));}catch(error){return false;}
      return data.id===id&&node.getClientRects().length>0;
    });
    if(visible)visible.scrollIntoView({block:'center',behavior:'auto'});
  });
})();

/* One visible inspector target per responsive field; rebind after section renders. */
(function () {
  if (!window.Shopify || !Shopify.designMode || window.__slEditorV4) return;
  window.__slEditorV4 = true;
  var queued = false;
  function refresh() {
    queued = false;
    document.querySelectorAll('.sl-section').forEach(function (section) {
      var groups = new Map();
      section.querySelectorAll('[data-sl-editor-meta]').forEach(function (node) {
        var probe = document.createElement('div');
        probe.innerHTML = '<i ' + node.getAttribute('data-sl-editor-meta') + '></i>';
        var value = probe.firstElementChild.getAttribute('data-shopify-editor-block');
        if (!value) return;
        var id = JSON.parse(value).id;
        if (!groups.has(id)) groups.set(id, []);
        groups.get(id).push({node: node, value: value});
      });
      groups.forEach(function (copies) {
        var chosen = copies.find(function (copy) {
          var rect = copy.node.getBoundingClientRect();
          return rect.width > 0 && rect.height > 0 && getComputedStyle(copy.node).visibility !== 'hidden';
        });
        copies.forEach(function (copy) {
          if (copy === chosen) copy.node.setAttribute('data-shopify-editor-block', copy.value);
          else copy.node.removeAttribute('data-shopify-editor-block');
        });
      });
    });
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(refresh); } }
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:reorder', schedule);
  window.addEventListener('resize', schedule);
  new MutationObserver(schedule).observe(document.body, {childList:true, subtree:true});
  function inspector(active) { document.documentElement.classList.toggle('sl-inspector-active', active); schedule(); }
  document.addEventListener('shopify:inspector:activate', function () { inspector(true); });
  document.addEventListener('shopify:inspector:deactivate', function () { inspector(false); });
  inspector(!!(Shopify.inspectMode));
  refresh();
})();

/* Smooche offer countdown and reading progress; supports theme-editor reloads. */
(function () {
  var observer, queued = false;
  function update() {
    queued = false;
    var offer = document.querySelector('[data-sl-offer][data-sticky="true"]');
    var height = offer ? offer.closest('.shopify-section').getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--sl-offer-height', height + 'px');
    var total = document.documentElement.scrollHeight - window.innerHeight;
    var percent = total > 0 ? Math.max(0, Math.min(100, window.scrollY / total * 100)) : 0;
    document.querySelectorAll('[data-sl-progress]').forEach(function (bar) {
      bar.setAttribute('aria-valuenow', Math.round(percent));
      bar.firstElementChild.style.transform = 'scaleX(' + percent / 100 + ')';
    });
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(update); } }
  function tick() {
    document.querySelectorAll('[data-sl-countdown]').forEach(function (timer) {
      var demo = timer.dataset.mode === 'demo';
      var duration = Math.max(5, Number(timer.dataset.minutes) || 20) * 60;
      var remaining = demo ? duration - Math.floor(Date.now() / 1000) % duration : Math.ceil((Date.parse(timer.dataset.deadline) - Date.now()) / 1000);
      var hidden = !Number.isFinite(remaining) || remaining <= 0;
      if (timer.hidden !== hidden) { timer.hidden = hidden; schedule(); }
      if (hidden) return;
      var values = {days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60};
      Object.keys(values).forEach(function (key) { var node = timer.querySelector('[data-unit="' + key + '"]'); var value = String(values[key]).padStart(2, '0'); if (node.textContent !== value) node.textContent = value; });
    });
  }
  function init() {
    if (observer) observer.disconnect();
    observer = new ResizeObserver(schedule);
    document.querySelectorAll('[data-sl-offer]').forEach(function (offer) { observer.observe(offer.closest('.shopify-section')); });
    tick(); schedule();
  }
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () { requestAnimationFrame(init); });
  document.addEventListener('shopify:section:reorder', schedule);
  init(); setInterval(tick, 1000);
})();

/* Independent phrase styles: text nodes only, preserving links and rich-text markup. */
(function(){
  'use strict';
  var cache=new WeakMap();
  function apply(scope){
    scope.querySelectorAll('[data-sl-phrases]').forEach(function(config){
      var section=config.closest('.shopify-section') || config.parentElement;
      var field=config.dataset.field;
      section.querySelectorAll('[data-sm-text="'+field+'"]').forEach(function(root){
        var signature=[1,2,3].map(function(n){return config.getAttribute('data-phrase-'+n)||'';}).join('\u0000');
        var previous=cache.get(root);if(previous&&previous.signature===signature&&previous.text===root.textContent&&previous.spans===root.querySelectorAll('[data-sl-phrase]').length)return;
        root.querySelectorAll('[data-sl-phrase]').forEach(function(span){span.replaceWith(document.createTextNode(span.textContent));});
        root.normalize();
        var nodes=[],text='',walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
        while(walker.nextNode()){var node=walker.currentNode;nodes.push({node:node,start:text.length,end:text.length+node.length});text+=node.data;}
        var matches=[];
        [1,2,3].forEach(function(n){
          var phrase=config.getAttribute('data-phrase-'+n);if(!phrase)return;
          var start=0,index;
          while((index=text.indexOf(phrase,start))!==-1){
            var end=index+phrase.length;
            if(!matches.some(function(m){return index<m.end&&end>m.start;}))matches.push({start:index,end:end,n:n});
            start=end;
          }
        });
        nodes.forEach(function(entry){
          var parts=matches.filter(function(m){return m.start<entry.end&&m.end>entry.start;}).sort(function(a,b){return a.start-b.start;});
          if(!parts.length)return;
          var fragment=document.createDocumentFragment(),cursor=0,raw=entry.node.data;
          parts.forEach(function(m){var start=Math.max(0,m.start-entry.start),end=Math.min(raw.length,m.end-entry.start);
            fragment.append(document.createTextNode(raw.slice(cursor,start)));
            var span=document.createElement('span');span.className='sl-phrase-'+m.n;span.dataset.slPhrase=String(m.n);span.textContent=raw.slice(start,end);fragment.append(span);cursor=end;
          });
          fragment.append(document.createTextNode(raw.slice(cursor)));entry.node.replaceWith(fragment);
        });
        cache.set(root,{signature:signature,text:root.textContent,spans:root.querySelectorAll('[data-sl-phrase]').length});
      });
    });
  }
  var pending=false;
  function schedule(){if(pending)return;pending=true;requestAnimationFrame(function(){pending=false;apply(document);});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule);else schedule();
  document.addEventListener('shopify:section:load',schedule);
  new MutationObserver(schedule).observe(document.documentElement,{childList:true,subtree:true});
})();

/* Mixed-media slots: control-free looping playback; pause hidden responsive copies. */
(function(){
  var mounted=new WeakSet();
  function init(scope){scope.querySelectorAll('video[data-sl-flex-video]').forEach(function(video){
    if(mounted.has(video))return;mounted.add(video);
    var pausedByUser=false,programmaticPause=false;
    var reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
    video.controls=false;video.removeAttribute('controls');video.disablePictureInPicture=true;video.disableRemotePlayback=true;video.loop=true;video.playsInline=true;
    video.autoplay=false;video.removeAttribute('autoplay');video.muted=true;
    function sync(){var r=video.getBoundingClientRect();var visible=!document.hidden&&r.width>0&&r.height>0&&r.bottom>0&&r.top<innerHeight;
      if(!visible){if(!video.paused){programmaticPause=true;video.pause();}return;}
      if(video.paused&&!pausedByUser&&!reduced.matches)video.play().catch(function(){});
    }
    video.addEventListener('pause',function(){if(programmaticPause){programmaticPause=false;}else pausedByUser=true;});
    video.addEventListener('play',function(){pausedByUser=false;});
    // Video controls inside linked offer artwork must not follow the offer link.
    video.addEventListener('click',function(e){if(video.closest('a'))e.preventDefault();});
    var observer=new IntersectionObserver(sync,{threshold:[0,0.01]});observer.observe(video);
    var resize=new ResizeObserver(sync);resize.observe(video);
    document.addEventListener('visibilitychange',sync);
    function cleanup(){if(video.isConnected)return;observer.disconnect();resize.disconnect();document.removeEventListener('visibilitychange',sync);document.removeEventListener('shopify:section:unload',cleanup);}
    document.addEventListener('shopify:section:unload',cleanup);sync();
  });}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);});else init(document);
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();
